import { render, staticRenderFns } from "./AssetVideoInfo.vue?vue&type=template&id=47dd2ad8&lang=pug"
import script from "./AssetVideoInfo.vue?vue&type=script&lang=js"
export * from "./AssetVideoInfo.vue?vue&type=script&lang=js"
import style0 from "./AssetVideoInfo.vue?vue&type=style&index=0&id=47dd2ad8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports